import React, {useMemo} from 'react'
import BreadcrumbItem from '../../../components/breadcrumb/breadcrumb-item'
import Breadcrumb from '../../../components/breadcrumb'
import useCustomerServicePageConfig from '../hooks/use-page-config'
import {useIntl} from 'react-intl'
import {normalizeSfccLink} from '../../../utils/url'
import {PAGE_BG_VAR} from '../../../leap/components/navigation/header/header-variant'

const CSBreadcrumbs = () => {
    const {locale} = useIntl()
    const pageConfig = useCustomerServicePageConfig()
    const {breadcrumbs} = pageConfig

    const normalizedBreadcrumbs = useMemo(
        () =>
            breadcrumbs?.map(({link, label}) => ({
                label,
                href: normalizeSfccLink(locale, link)
            })) ?? [],
        [breadcrumbs, locale]
    )

    return (
        <Breadcrumb variant="sunset" bg={`var(${PAGE_BG_VAR})`}>
            {normalizedBreadcrumbs.map(({label, href}, index) => (
                <BreadcrumbItem key={index} href={href}>
                    {label}
                </BreadcrumbItem>
            ))}
        </Breadcrumb>
    )
}

export default CSBreadcrumbs
